import type { Project } from '@app/api/team';

export enum ConfirmationType {
    overLimit = 'overLimit',
    overLimitNoTrial = 'overLimitNoTrial',
    chargeImmediately = 'chargeImmediately',
    chargeImmediatelyNoSeats = 'chargeImmediatelyNoSeats',
    upgradeToEnterprise = 'upgradeToEnterprise',
}

export enum LanguagesFields {
    contributableLanguages = 'contributableLanguages',
    referenceLanguages = 'referenceLanguages',
}

export enum AddContributorsModalPage {
    project = 'project',
    team = 'team',
}

type CommonProps = {
    planName: string;
    teamName: string;
    page: AddContributorsModalPage;
    isExtraSeatsAllowed: boolean;
    seatsTaken: number;
    seatsLimit: number;
    invitedSeats: number;
    gracePeriodSeats: number;
    isProviderAlpha: boolean;
};

export type AddContributorsModalProps = {
    teamMembers?: [];
    groups?: [];
    isGroupsEnabled?: boolean;
    activeProject?: Project;
} & CommonProps;

export type InviteNewUserProps =
    | ({
          page: AddContributorsModalPage.team;
          projects: Project[] | undefined;
          onModalTitleChange: (title: string) => void;
          onClose: () => void;
      } & CommonProps)
    | ({
          page: AddContributorsModalPage.project;
          activeProject: Project;
          onModalTitleChange: (title: string) => void;
          onClose: () => void;
      } & CommonProps);

export enum Role {
    admin = 'admin',
    translator = 'translator',
}

export type StringSelectOption = {
    label: string;
    value: string;
};

export type NumberSelectOption = {
    label: string;
    value: number;
};

export type AddExistingUsersFormSubmitValues = {
    teamMembers: StringSelectOption[];
    role: StringSelectOption;
    isReviewer: boolean;
    referenceLanguages: NumberSelectOption[] | null;
    contributableLanguages: NumberSelectOption[] | null;
};

export type AddExistingUsersFormProps = {
    project: Project;
    teamMembers: { label: string; value: string }[];
    isSubmitting: boolean;
    onFormChange: (formValues: AddExistingUsersFormSubmitValues) => void;
    onValidate: (isReady: boolean) => void;
};

export type InviteNewUserSubmitValues = {
    contributors: string[];
    project: StringSelectOption | null;
    role: StringSelectOption;
    isReviewer: boolean;
    referenceLanguages: NumberSelectOption[] | null;
    contributableLanguages: NumberSelectOption[] | null;
};

export type ReadyToValidateCallback = {
    isReady: boolean;
    form: InviteNewUserSubmitValues;
};

export type InviteNewUserFormProps = {
    projects?: Project[];
    activeProject?: Project;
    isSubmitting: boolean;
    onReadyToValidate: ({ isReady, form }: ReadyToValidateCallback) => void;
    onFormChange: (formValues: InviteNewUserSubmitValues) => void;
    exceedingLimit?: boolean;
};

export type LanguageChangeHandlerPayload = {
    values: InviteNewUserSubmitValues | AddExistingUsersFormSubmitValues;
    field: LanguagesFields;
    languages: readonly NumberSelectOption[];
};

export type LanguageChangeHandlerResults = {
    referenceLanguages: NumberSelectOption[] | null;
    contributableLanguages: NumberSelectOption[] | null;
};
